import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/cgv")({
  head: () => ({
    meta: [
      { title: "Conditions Générales de Vente — Rénergescence" },
      { name: "description", content: "Conditions Générales de Vente du cabinet Rénergescence — Caroline Balech, Toulouse." },
      { property: "og:title", content: "CGV — Rénergescence" },
      { property: "og:url", content: "/cgv" },
    ],
    links: [{ rel: "canonical", href: "https://renergescence.com/cgv" }],
  }),
  component: CGV,
});

function Article({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-2xl font-light md:text-3xl" style={{ color: "#2D2B28" }}>{title}</h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed" style={{ color: "#4A4742" }}>{children}</div>
    </section>
  );
}

function CGV() {
  return (
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-[760px] px-6">
        <p className="eyebrow">Informations légales</p>
        <h1 className="mt-4 font-display text-5xl font-light italic md:text-6xl">Conditions Générales de Vente</h1>

        <Article title="Article 1 — Objet">
          <p>Les présentes Conditions Générales de Vente (CGV) s'appliquent à l'ensemble des prestations de services (santé naturelle, soins énergétiques, techniques manuelles de bien-être) et à la vente de bons cadeaux proposés par Caroline BALECH au sein du cabinet Rénergescence. Tout rendez-vous pris implique l'acceptation sans réserve des présentes conditions.</p>
        </Article>

        <Article title="Article 2 — Tarifs et modalités de paiement">
          <p>Les tarifs appliqués sont ceux en vigueur pour l'année 2026, affichés de manière transparente sur le site internet. TVA non applicable, art. 293 B du CGI.</p>
          <p>Le cabinet accepte les modes de paiement suivants : espèces et virements bancaires. Le règlement s'effectue le jour de la prestation au cabinet. Pour les consultations à distance, le règlement par virement doit être validé avant le début du soin.</p>
        </Article>

        <Article title="Article 3 — Conditions d'annulation et de report">
          <p>Afin de garantir le bon fonctionnement du cabinet et le respect du temps de chacun, tout empêchement doit être signalé au moins 48 heures avant la date du rendez-vous par téléphone ou par e-mail. En cas de non-respect de ce délai de 48 h, la séance sera considérée comme due et aucun remboursement ou report ne sera accordé.</p>
        </Article>

        <Article title="Article 4 — Bons cadeaux">
          <p>Les bons cadeaux achetés sur le site ou au cabinet ont une durée de validité de 6 mois à compter de leur date d'émission. Ils ne sont ni échangeables, ni remboursables. Ils peuvent être configurés pour une prestation précise ou pour un montant libre. La carte cadeau est envoyée par e-mail sous 24 h.</p>
        </Article>

        <Article title="Article 5 — Clause de non-substitut médical">
          <p>Conformément au cadre légal et à la déontologie du cabinet, les prestations proposées sont des accompagnements de bien-être et de santé naturelle complémentaires. Ils ne remplacent en aucun cas un diagnostic, un suivi ou un traitement médical.</p>
        </Article>

        <Article title="Article 6 — Litiges et médiation">
          <p>En cas de litige non résolu à l'amiable, le client peut faire appel au médiateur de la consommation choisi par le cabinet : CNPM — Médiation de la consommation (<a href="https://cnpm-mediation-consommation.eu" target="_blank" rel="noopener noreferrer" className="underline" style={{ color: "var(--color-sage-text)" }}>cnpm-mediation-consommation.eu</a>).</p>
        </Article>
      </div>
    </section>
  );
}